import React, { useState } from "react"
import { useLoading } from "helpers/custom_hooks"
import { UpdateQCRequest } from "helpers/backend_helper"
import { displayMessage } from "helpers/misc_helpers"
import { Col, Row } from "reactstrap"
import moment from "moment"

const QCGoodsReceived = ({ entry, myUser, statusIndex, reload }) => {
  const setLoading = useLoading()

  const handleSave = async () => {
    setLoading(true)
    try {
      entry.dateQCLabReceivedGoods = new Date()
      entry.statusIndex++

      await UpdateQCRequest(entry)
      reload()
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }
  }

  const IsUserQCLabor = () => myUser?.company?.id == entry?.qcLaborID

  return (
    <>
      {entry?.statusIndex >= statusIndex ? (
        <li
          className={
            "event-list " + (entry?.statusIndex == statusIndex ? "active" : "")
          }
        >
          <div
            className={
              "event-timeline-dot " +
              (entry?.statusIndex == statusIndex ? "bx-fade-right" : "")
            }
          >
            <i className="bx bx-right-arrow-circle font-size-18"></i>
          </div>
          <div className="d-flex">
            <div className="flex-shrink-0 me-3">
              <h5 className="font-size-14">
                {moment(entry.dateQCLabReceivedGoods).format("DD.MM.YYYY")}{" "}
                <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
            </div>
            <div className="flex-grow-1">
              <div>QC Lab is currently testing the parts</div>
            </div>
          </div>
          <div className="mt-2">
            <p className="mb-0" style={{ cursor: "pointer" }}>
              Goods arrived at the QC Lab{" "}
              {entry?.additionalCosts && (
                <>
                  <br /> The QC Lab is now conducting the additional tests.
                </>
              )}
            </p>
          </div>
        </li>
      ) : (
        entry?.statusIndex == statusIndex - 1 &&
        IsUserQCLabor() && (
          <Row>
            <Col
              className="px-5"
              style={{ maxWidth: "400px", minWidth: "150px" }}
            >
              <p>
                When the package arrives at your company, please mark the
                request as “Arrived” using the button below.
              </p>
              <button
                type="button"
                onClick={handleSave}
                className="btn btn-primary"
              >
                Mark as arrived
              </button>
            </Col>
          </Row>
        )
      )}
    </>
  )
}

export default QCGoodsReceived
